import { gql } from '@apollo/client';
import React from 'react';
import EntityPill from '../components/EntityPill';
import type { PostPill_PostFragment } from '../graphql/generated/graphqlTypes';
import postPath from '../utils/url/postPath';
import PostDetailPreviewPopOver from './PostDetailPreviewPopOver';

const POST_PILL_POST_FRAGMENT = gql`
  fragment PostPill_post on Post {
    id
    title
    ...postPath_post
  }
  ${postPath.fragments.post}
`;

interface PostPillProps
  extends Pick<
    React.ComponentProps<typeof EntityPill>,
    'icon' | 'tooltip' | 'onRemove'
  > {
  post: PostPill_PostFragment;
}

const PostPill = ({ onRemove, post, icon, tooltip }: PostPillProps) => {
  const content = (
    <EntityPill
      onRemove={onRemove}
      to={postPath(post)}
      type="post"
      icon={icon}
      tooltip={tooltip}
    >
      {post.title}
    </EntityPill>
  );

  if (tooltip) {
    return <>{content}</>;
  }
  return (
    <PostDetailPreviewPopOver display="inline-block" postId={post.id}>
      {content}
    </PostDetailPreviewPopOver>
  );
};

PostPill.fragments = {
  post: POST_PILL_POST_FRAGMENT,
};

export default PostPill;
